import EaseData from './behaviors/easedata/EaseData.js';

export {
    EaseData
};